import * as React from 'react';

import { ContentDetailSection } from './ContentDetailSection';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { L10n } from '../../../ts/L10n/L10n';
import { Messages } from '../../../codegen/Localize';

export interface SimpleDetailSectionProps {
  readonly content: IContentInfo<ExplorableItemType>;
}

export function CreatedDetailSection(props: SimpleDetailSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={Messages.created()}
      detail={L10n.localizedDateTime(props.content.createdAt)}
    />
  );
}

export function ModifiedDetailSection(props: SimpleDetailSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={Messages.modified()}
      detail={L10n.localizedDateTime(props.content.updatedAt)}
    />
  );
}
